import React, { useState } from 'react';
import {
    Row,
    Col,
    Button,
    Form,
    Input,
    notification,
} from "antd";
import authService from "../../api/auth.service";
import { SUCCESS_STATUS } from "../../utility/Constants";
import jwt_decode from "jwt-decode";

const ChangePassComp = () => {
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);

    const getUserIdFromToken = () => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && user.token) {
            const decodedToken = jwt_decode(user.token);
            return decodedToken.user_id;
        }
        return null;
    };

    const handleChangePassword = async (values) => {
        setIsLoading(true);
        const { currentPassword, newPassword } = values;
        const user_id = getUserIdFromToken();

        if (!user_id) {
            notification.error({
                message: 'Error',
                description: 'User ID not found!',
            });
            setIsLoading(false);
            return;
        }

        const data = {
            user_id: user_id,
            current_password: currentPassword,
            new_password: newPassword,
        };

        try {
            const response = await authService.changePassword(data);

            if (response.response_status === SUCCESS_STATUS) {
                notification.success({
                    message: 'Password Changed Successfully',
                    description: response.response_msg
                });
                form.resetFields();
                // authService.logout();
                // window.location.href = '/login';
            } else {
                notification.error({
                    message: 'Password Change Failed',
                    description: response.msg,
                });
            }
        } catch (error) {
            notification.error({
                message: 'Error',
                description: 'Something went wrong!',
            });
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div className="form-input-style"
            style={{
                background: "#f4f4f4",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh",
                padding: "20px"
            }}>
            <Row className="login-first-step-row" >
                <Col className="form-format-type1 enrollment-form jcp-enrollment" xs={24} xl={24}>
                    <Form
                        form={form}
                        layout="vertical"
                        autoComplete="off"
                        onFinish={handleChangePassword}
                    >
                        <Row gutter={20}
                            style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>


                            <Col xs={24} xl={24} >
                                <Col xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                    <h1 style={{
                                        margin: "0.5rem",
                                        fontSize: "18px",
                                        color: "#ed1909",
                                        fontWeight: "bold",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>
                                        Change Password
                                    </h1>
                                </Col>
                                <Col xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                    <Form.Item
                                        name="currentPassword"
                                        label="Current Password"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Enter Current Password",
                                            },
                                        ]}
                                    >
                                        <Input.Password style={{ width: "100%" }} placeholder="Enter Current Password" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                    <Form.Item
                                        name="newPassword"
                                        label="New Password"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Enter New Password",
                                            },
                                        ]}
                                    >
                                        <Input.Password style={{ width: "100%" }} placeholder="Enter New Password" />
                                    </Form.Item>
                                </Col>
                            </Col>

                            <Col xs={24} xl={24} >
                                <Col xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                    <Form.Item
                                        name="confirmPassword"
                                        label="Confirm Password"
                                        dependencies={['newPassword']}
                                        hasFeedback
                                        rules={[
                                            {
                                                required: true,
                                                message: "Enter Confirm Password",
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('newPassword') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('Password mismatch!'));
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password style={{ width: "100%" }} placeholder="Enter Password Again" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={24} style={{ display: "flex", justifyContent: "center", margin: "0.5rem" }}>
                                    <Form.Item label=" ">
                                        <Button
                                            htmlType="submit"
                                            shape="round"
                                            loading={isLoading}
                                            className="custom-button-green"
                                        >
                                            Save
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};

export default ChangePassComp;
